export const correctAns =[
	"✔️🚀🚨🌟☄️🌈❄️🔥💧🌊💯Brilliant!  😍",
	"You are amazing! 💕",
	"Are you a genius? 😘",
	"How are you doing this? 😁",
	"Excellent! 🍀🍀",
	"Wonderful! 🙌",
	"Congratulations! 🤞",
	"Are you cheating? 😁",
	"You got lucky this time 🤩",
	"You are unreal! 🥰",
	"Unstoppable 🙌"

]
export const incorrectAns =[
	"Unlucky! 😒",
	"Try again! 🥹",
	"Are you doing ur best? 🤨",
	"You can do this! 😉",
	"Nice try 🙂",
	"Don’t worry! 🫡" ,
	"Cheer up! 🙃",
	"You failed! 😑",
    "Oh no ...!",
    "Try try 🥹",
    "Don't give up! 😖"
]